import { RouteProps } from "react-router";
import { UserRoleEnum } from "@models/users.models";
import { HomeRouterNames } from "./home-router.names";
import React from "react";

export interface RouteConfig extends RouteProps {
  permission?: UserRoleEnum[];
}
export const homeRouterConfig: RouteConfig[] = [
  {
    path: `/${HomeRouterNames.DASHBOARD}`,
    component: React.lazy(() => import("../pages/dashboard-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.EMPLOYEES}`,
    component: React.lazy(() => import("../pages/employees-page")),
  },
  {
    path: `/${HomeRouterNames.SYSTEM_USER}`,
    component: React.lazy(() => import("../pages/system-user-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.SYSTEM_SETTING}`,
    component: React.lazy(() => import("../pages/system-setting-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.ORGANISATION_SETUP}`,
    component: React.lazy(
      () => import("../pages/system-setting-page/OrganisationSetup")
    ),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.SYSTEM_SETTING}/organisation-setup`,
    component: React.lazy(
      () => import("../pages/system-setting-page/OrganisationSetup")
    ),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.UPCOMING_NOTIFICATIONS}`,
    component: React.lazy(
      () => import("../pages/upcoming-notifications-page")
    ),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.ALL_CASES}/:caseType`,
    component: React.lazy(() => import("../pages/all-cases-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.REQUESTS}`,
    component: React.lazy(() => import("../pages/requests-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.CALENDAR}`,
    component: React.lazy(() => import("../pages/calendar-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.REDUNDANCY_CALCULATOR}`,
    component: React.lazy(() => import("../pages/redundancy-calc-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.STORE_DETAILS}`,
    component: React.lazy(() => import("../pages/stores-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.STORE_DETAILS}/employees`,
    component: React.lazy(() => import("../pages/stores-page/store-employees")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.TASKS}`,
    component: React.lazy(() => import("../pages/tasks-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.TIME_ATTENDANCE}`,
    component: React.lazy(() => import("../pages/time-attendance-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.SCHEDULING}`,
    component: React.lazy(() => import("../pages/scheduling_v2")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.NOTIFICATION_LOGS}`,
    component: React.lazy(() => import("../pages/notification-log")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.CANDIDATES}`,
    component: React.lazy(() => import("../pages/candidates-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET}`,
    component: React.lazy(() => import("../pages/fleet-page")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_VEHICLES}`,
    component: React.lazy(() => import("../pages/fleet-vehicles/FleetVehiclesPage")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_ADMIN_NOTIFICATIONS}`,
    component: React.lazy(() => import("../pages/notifications/NotificationsPage")),
    exact: true,
  },  {
    path: `/${HomeRouterNames.FLEET_NOTIFICATION_POPUPS}`,
    component: React.lazy(() => import("../pages/fleet-notification-popups/FleetNotificationPopupsPage")),
    exact: true,
  },

  {
    path: `/${HomeRouterNames.FLEET_ALERTS}`,
    component: React.lazy(() => import("../pages/fleet-alerts/FleetAlertsPage")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_AI_INSIGHTS}`,
    component: React.lazy(() => import("../pages/fleet-ai-insights/FleetAiInsightsPage")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_MAINTENANCE}`,
    component: React.lazy(() => import("../pages/fleet-maintenance/FleetMaintenancePage")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.DAMAGE}`,
    component: React.lazy(() => import("../pages/damage-analysis/DamageAnalysis")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_INSPECTION_DETAIL}`,
    component: React.lazy(() => import("../pages/damage-analysis/DamageAnalysis")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.INCIDENTS}`,
    component: React.lazy(() => import("../pages/incidents/Incidents")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.INCIDENT_DETAIL}`,
    component: React.lazy(() => import("../pages/incidents/IncidentDetail")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.MetricsUpload}`,
    component: React.lazy(() => import("../pages/metrics&upload/MetricsUpload")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.TeamScorecard}`,
    component: React.lazy(() => import("../pages/metrics&upload/MetricsUpload")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.DriverScorecard}`,
    component: React.lazy(() => import("../pages/driver-scorecard/DriverScorecard")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.DriverScorecardDetail}`,
    component: React.lazy(() => import("../pages/driver-scorecard/DriverDetailPage")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_SETTINGS}`,
    component: React.lazy(() => import("../pages/fleet-settings/FleetSettings")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.AUTO_ROSTER}`,
    component: React.lazy(() => import("../pages/auto-roster")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_HEALTH_REPORT}`,
    component: React.lazy(() => import("../pages/fleet-health-report/FleetHealthReportPage")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.FLEET_COACHING_TIPS}`,
    component: React.lazy(() => import("../pages/coaching-tips/CoachingTipsPage")),
    exact: true,
  },
  /* {
    path: `/${HomeRouterNames.AUDIT_LOG}`,
    component: React.lazy(() => import("../pages/audit-log/AuditLog")),
    exact: true,
  },
  {
    path: `/${HomeRouterNames.WORKFORCE}`,
    component: React.lazy(() => import("../pages/workforce/Workforce")),
    exact: true,
  } */
];
